import React from 'react'
import Image from 'next/image'
import IconButton from '../IconButton'

const WHEELCHAIR = 'wheelchairAccessible'
const VISION = 'visuallyImpaired'

const AccessibilityOverlay = ({ filters, handleClick }) => (
  <div>
    <h4>Toegankelijkheid</h4>
    <p>Toon locaties met bekende toegankelijkheid voor:</p>
    <IconButton
      title='Knop voor rolstoeltoegangelijkheid filter'
      id={WHEELCHAIR}
      onClick={handleClick}
      active={filters.includes(WHEELCHAIR)}
    >
      <Image alt='Icoon van rolstoel' src='/assets/icons/wheelchair.svg' width={16} height={16} />
    </IconButton>
    {/* Tijdelijk disabled omdat er geen functionaliteiten voor slechtzienden zijn */}
    {false && (
      <IconButton
        title='Knop voor slechtzienden filter'
        id={VISION}
        onClick={handleClick}
        active={filters.includes(VISION)}
      >
        <Image
          alt='Icoon van slechtziend oog'
          src='/assets/icons/low-vision.svg'
          width={16}
          height={16}
        />
      </IconButton>
    )}
  </div>
)

export default AccessibilityOverlay
